var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 363.24 406.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Unbenannter_Verlauf_28);}.cls-2{fill:#2f5f4a;}.cls-3{fill:#693b32;}.cls-4{fill:#8c4e42;}.cls-5{fill:#043e66;}.cls-6{fill:#4a4254;}.cls-7{fill:#054b82;}.cls-8{fill:#ffa895;}.cls-9{fill:#d85b52;}.cls-10{fill:#beb09e;}.cls-11{fill:#3a3442;}.cls-12{fill:#ff807d;}.cls-13{fill:#fdead2;}.cls-14{fill:#aa614f;}.cls-15{fill:#f96f5d;}.cls-16{fill:#24243d;}.cls-17{fill:#23262d;}.cls-18{fill:#3e7f63;}.cls-19{fill:#4fa381;}.cls-20{fill:#6993b4;}.cls-21{fill:#8ca540;}.cls-22{fill:#4a7e2c;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_28",
    x1: 67.52,
    y1: 116.41,
    x2: 239.22,
    y2: 288.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d9e4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#dbe5f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#e4ebf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#f2f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "startseite"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.1,406.93c11.58-7.5,18.78-20.71,30.3-29.18,15.26-11.22,33-20.51,51.59-24.48,30.28-6.46,64.13-7.03,90.42-26.05,41.89-30.32,44.11-83.42,70.46-122.95,26.53-39.8,91.47-42.39,94.29-98.34,2.87-57.09-68.24-96.04-117-103.82-36.32-5.79-62.85-.34-88.85,24.64-31.58,30.34-56.66,63.03-77.16,101.95-31.14,59.13-60.72,124.85-75.71,190.29-4.03,17.59-14.12,82.8,21.67,87.94Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m97.67,118.24l-.2,10.63-2.63-8.39c-14.33,10.3-16.26,26.73-16.1,35.86-.15,5.15.87,32.57.87,32.57h2.4c-1.35-17.74,2.3-32.69,2.3-32.69,2.24-2.85,4.63-5.68,7.09-8.46.52-.58,1.04-1.17,1.56-1.75,3.94-4.36,8.01-8.55,11.92-12.4,12.11-11.92,22.64-20.54,22.64-20.54-18.5-2.8-29.88,5.16-29.88,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m82.51,196.24c.16-9.13-1.77-25.55-16.1-35.86l-2.63,8.39-.2-10.63s-11.38-7.96-29.88-5.16c0,0,10.53,8.62,22.64,20.54,3.91,3.85,7.98,8.04,11.92,12.4.52.58,1.04,1.16,1.56,1.75,2.46,2.78,4.85,5.61,7.09,8.46,0,0,3.66,14.95,2.3,32.69h2.4s1.02-27.42.87-32.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m104.15,145.97l-.2,10.63-2.63-8.39c-14.33,10.3-16.26,26.73-16.1,35.86-.15,5.15.87,32.57.87,32.57h2.4c-1.35-17.74,2.3-32.69,2.3-32.69,2.24-2.85,4.63-5.68,7.09-8.46.52-.59,1.04-1.17,1.56-1.75,3.94-4.36,8.01-8.55,11.92-12.4,12.11-11.92,22.64-20.54,22.64-20.54-18.5-2.8-29.88,5.16-29.88,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m103.94,238.3c-1.95,2.42-4.9,3.81-8,3.81h-24.54c-3.36,0-6.52-1.63-8.44-4.4-7.69-11.12-8.22-22.59.41-34.61h40.16c9.12,11.76,9.84,23.48.41,35.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "112.19 242.11 112.19 246.27 107.12 246.27 97.47 248.34 83.87 251.26 60.52 246.27 55.55 246.27 55.55 242.11 112.19 242.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "112.19 242.11 112.19 246.27 107.12 246.27 97.47 248.34 91.61 242.11 112.19 242.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m58.43,358.93h0c-1.59,0-2.88-1.29-2.88-2.88v-120.62c0-1.59,1.29-2.88,2.88-2.88h0c1.59,0,2.88,1.29,2.88,2.88v120.62c0,1.59-1.29,2.88-2.88,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m109.31,358.93h0c-1.59,0-2.88-1.29-2.88-2.88v-120.62c0-1.59,1.29-2.88,2.88-2.88h0c1.59,0,2.88,1.29,2.88,2.88v120.62c0,1.59-1.29,2.88-2.88,2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m83.76,358.93h0c-1.59,0-2.88-1.29-2.88-2.88v-120.62c0-1.59,1.29-2.88,2.88-2.88h0c1.59,0,2.88,1.29,2.88,2.88v120.62c0,1.59-1.29,2.88-2.88,2.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m103.94,238.3c-1.95,2.42-4.9,3.81-8,3.81h-6.16c2.21-3.49,11.45-19.45,8.74-39h5.01c9.12,11.76,9.84,23.48.41,35.19Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "80.92 235.01 80.76 235.37 77.59 242.33 80.88 242.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 35.11,
    y: 358.37,
    width: 238.74,
    height: 2.14,
    rx: 0.57,
    ry: 0.57,
    transform: "translate(308.96 718.88) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "138.74 189.43 145.09 263.29 149.55 342.93 165 342.93 169.29 207.5 171.55 207.5 198.13 342.93 212.37 342.93 208.94 281.83 206.91 188.53 202.07 184.5 158.99 185.7 138.74 189.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "138.74 189.43 207.15 199.6 206.91 188.53 201.04 181.93 150.92 181.93 138.74 189.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "171.55 207.5 163.11 199.6 169.29 207.5 171.55 207.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "147.32 338.99 148.86 344.31 166.2 344.31 167.06 337.79 147.32 338.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "194.52 337.79 196.75 344.31 213.06 344.31 214.26 337.79 194.52 337.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m151.78,344.31s-2.23,2.38-4.46,3.68c-2.23,1.3-14.76,2.85-13.9,10.23h31.07s-.34-7.58,0-10.23c.34-2.65,0-3.68,0-3.68h-12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m211.48,344.31s2.23,2.38,4.46,3.68c2.23,1.3,14.76,2.85,13.9,10.23h-31.07s.34-7.58,0-10.23c-.34-2.65,0-3.68,0-3.68h12.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "165.16 337.79 165.43 329.38 149 338.88 165.16 337.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "197.12 337.79 195.77 330.94 212.37 337.79 197.12 337.79"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m204.49,122.45l15.83-1.83s-2.19-44.77-35.73-45.23l-16.99-.39h-8.44s-18.15-.57-27.16,13.49c-5.97,9.3-9.89,31.94-9.89,31.94l17.09,2.01-1.45,52.01s-2.31,3.66-.96,6.36c1.35,2.7-.58,10.6-.58,10.6l75.36-1.16-7.07-67.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m186.11,95.26v23.72c0,2.73-2.21,4.94-4.94,4.94h-18.31c-2.73,0-4.94-2.21-4.94-4.94v-23.72h28.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m186.11,95.26v23.72c0,2.73-2.21,4.94-4.94,4.94h-10.27c4.18-8.88,5.51-22.88,5.89-28.66h9.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m184.67,43.89l3.21-3.02s5.54-5.47,3.59-13.61c-2.5-10.4-19.47-9.83-26.46-3.4,0,0-8.97-2.18-14.38,5.1-6.49,8.74-4.11,31.38,11.17,34.21,16.92,3.14,22.87-19.28,22.87-19.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m187.88,40.86c-8.32.86-12.1-6.05-12.1-6.05-7.94,8.13-16.99,3.97-16.99,3.97,4.51,6.38-.97,10.96-.97,10.96,0,0-2.08-4.35-3.97-3.97-1.89.38-4.73,2.27-1.89,7.18,2.84,4.91,7.56,2.84,7.56,2.84,3.02,2.83,2.27,7.37,2.27,7.37l-1.27,11.65-1.36.19s3.87,10.36,11.38,9.25c7.52-1.11,10.04-8.96,10.04-8.96l-2.19.14h0l-1.48-8.87s5.67,2.08,9.64-3.97c3.97-6.05,1.32-21.74,1.32-21.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "176.92 66.57 165.96 62.98 178.02 73.16 176.92 66.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "138.08 161.03 154.22 123.91 138.08 146.76 138.08 161.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "189.98 123.7 208.52 161.03 207.09 143.31 189.98 123.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "139.19 122.45 143.56 101.39 142.25 122.45 139.08 125.59 139.19 122.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "204.49 122.45 199.53 103.59 200.38 121.64 204.6 125.59 204.49 122.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m123.68,120.62l15.51,1.83-.11,3.14,13.21-12.1s-.66-7.04,0-8.12c.66-1.08,2.57-4.15,4.48-4.56,1.91-.41,8.21,3.61,8.21,3.61,0,0-.58,2.11-2.57,2.36-1.99.25-4.06.08-4.06.08l-.44,8.78s-10.29,26.38-24.27,37.14c0,0-11.53-10.85-9.95-32.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m139.08,125.59l-12.75,15.1s-4.23-10.86-2.65-20.07l15.51,1.83-.11,3.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "158.34 106.86 154.61 106.11 158.22 109.27 158.34 106.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m219.68,120.62l-15.19,1.83.11,3.14-12.93-12.1s.65-7.04,0-8.12c-.65-1.08-2.52-4.15-4.39-4.56-1.87-.41-8.04,3.61-8.04,3.61,0,0,.57,2.11,2.52,2.36,1.95.25,3.98.08,3.98.08l.43,8.78s10.32,27.13,23.76,37.14c0,0,11.29-10.85,9.74-32.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m204.6,125.59l12.48,15.1s3.78-10.03,2.6-20.07l-15.19,1.83.11,3.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "185.74 106.86 189.39 106.11 185.86 109.27 185.74 106.86"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m160.18,114.59s-6.89-7.53-.5-12.95c0,0,2.76-2.73,5.38-.83,0,0,3.95-3.15,7.42-.44,3.47,2.71-11.72,6.53-12.3,14.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m165.06,100.81s-5.79,4.12-4.88,13.78c0,0-6.89-7.53-.5-12.95,0,0,2.76-2.73,5.38-.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m189.91,100.57s6.51-10.07-1.96-15.09c0,0-3.74-2.62-6.4.09,0,0-5.19-2.88-8.68.94-3.49,3.83,14.85,5.27,17.04,14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m181.55,85.57s7.51,3.64,8.36,15.01c0,0,6.51-10.07-1.96-15.09,0,0-3.74-2.62-6.4.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m174.06,80.79s-8.09.5-11,10.5c0,0,.02-12.97,6.17-13.83,4.54-.64,4.82,3.33,4.82,3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m165.9,95.45c-2.01-5.35-7.46-5.07-7.52-5.07l-.07-1.1c.07-.01,6.33-.32,8.62,5.78l-1.03.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m176.88,82.36c-3.28.84-5.06,7.12-5.8,10.61-.47-1.14-1.19-2.26-2.17-2.26h-.01c-.82.01-1.86.64-3.05,4.54-.43,1.36-.86,3.14-1.32,5.44l1.08.22c.5-2.52.98-4.34,1.39-5.66.29-.95.57-1.63.81-2.13.57-1.19.98-1.3,1.1-1.32.54,0,1.35,1.79,1.74,3.44h1.13c.47-3.12,2.35-11.07,5.38-11.84,1.16-.29,2.49.54,3.96,2.48l.88-.66c-1.76-2.33-3.47-3.3-5.12-2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m174.64,95.37l-1.07-.23c2.91-13.59-1.29-15.49-1.34-15.51l.39-1.03c.21.08,5.17,2.07,2.02,16.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m160.32,89.88s-6.29,1.84-6.78,10.25c0,0-2.31-10.23,2.38-12.01,3.46-1.32,4.4,1.76,4.4,1.76Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m252.51,305.8s7.08-24.9,30.72-34.13c0,0,14.28-5.81,24.52-2.91,0,0-13.45-12.77-33.24-.9-6.28,3.77-11.49,9.14-15.17,15.47-3.21,5.53-6.51,13.34-6.82,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m245.71,292.28s-.62-45.99,19.4-68.92c0,0-12.95,55.31-12.61,67.42l-6.8,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m255.18,290.45c2.87-11.21,12.97-40.24,28.3-52.52,0,0-20.1,3.41-31.73,40.95,0,0-4.3,15.17-3.92,30.72l3.43-7.8c1.61-3.67,2.92-7.46,3.92-11.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m243.93,300.81s-7.08-24.9-30.72-34.13c0,0-14.28-5.81-24.52-2.91,0,0,13.45-12.77,33.24-.9,6.28,3.77,11.49,9.14,15.17,15.47,3.21,5.53,6.51,13.34,6.82,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m240.51,280.16c-2.13-11.37-10.29-41.01-24.78-54.27,0,0,19.83,4.73,28.96,42.95,0,0,3.29,15.42,1.89,30.91l-2.91-8.01c-1.37-3.77-2.43-7.64-3.16-11.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m269.14,287.61c.56,43.73-11.14,70.6-11.14,70.6h-18.2s-11.69-26.87-11.13-70.6h40.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m269.14,287.61c.56,43.73-11.14,70.6-11.14,70.6h-11.33c5.25-10.78,15.31-36.55,11.69-70.6h10.79Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage2);
export default __webpack_public_path__ + "static/media/image2.919e61fb69df87363943f01178de0375.svg";
export { ForwardRef as ReactComponent };